module.exports = __webpack_public_path__ + "static/media/ind.ed3af691.png";